<section>
  <h2>Anmeldung zum video2manual-Webinar</h2>
  <p>Vielen Dank für Ihr Interesse an unserem kostenlosen Live-Webinar.</p>
  <p>Hierüber informieren wir Sie in dem ca. 45-minütigen Termin:</p>
  <h4>Mit dem Einsatz von Utility Filmen die Arbeit der Zukunft gestalten</h4>

  <p>
    Die Arbeitswelt befindet sich im Wandel. Nicht nur Entwicklungen wie die KI
    beeinflussen die Arbeit der Technischen Redakteure, sondern auch die sich
    ändernden Voraussetzungen der Arbeitskräfte stellen die Technische Redaktion
    vor Herausforderungen.<br />
    Leseunverständnis und immer kürzer werdende Aufmerksamkeitsspannen fordern
    ein Umdenken beim Beschreiben von komplexen Arbeitsabläufen.
  </p>
  <p>Wie also schaffen Sie den Spagat zwischen diesen Anforderungen?</p>
  <p>Eine Abhilfe schafft der Utility Film.</p>
  <p>Wir laden Sie herzlich zu unserem Webinar ein.</p>
  <p></p>
  <p>Sie erfahren:</p>
  <ul class="webinar-content">
    <li>was ein Utility Film ist,</li>
    <li>worin die Vorteile liegen,</li>
    <li>was bei der Aufnahme der Clips beachtet werden sollte und</li>
    <li>wie man aus den Clips einen Utility Film erstellt.</li>
  </ul>
  <p>
    Die nächsten Termine stehen fest (siehe unten). Melden Sie sich auch an,
    wenn Sie an diesem Tag keine Zeit haben; wir senden Ihnen im Anschluss die
    Aufzeichnung zu.
  </p>
  <!-- <p>
    Der nächste Termin wird in Kürze bekannt gegeben. Bei Interesse an einer
    Software-Präsentation nutzen Sie gerne das untenstehende Formular. Wir
    setzen uns dann mit Ihnen in Verbindung.
  </p> -->
  <hr />
  <form #webinarForm="ngForm">
    <div class="form" [hidden]="isSended">
      <div class="picture">
        <img src="assets/v2m-logo.svg" />
      </div>
      <div class="text">
        <p>
          Füllen Sie das Formular bitte möglichst vollständig aus, damit wir Sie
          erreichen können.
        </p>
        <p>
          Die mit einem Stern (*) gekennzeichneten Felder sind Pflichtfelder.
        </p>
      </div>
      <div class="date">
        <select
          class="form-control"
          id="date"
          name="date"
          [(ngModel)]="date"
          [disabled]="isSending || isSended"
        >
          <option value="1">19. März 2024, 10:00 Uhr</option>
          <option value="2">23. April 2024, 10:00 Uhr</option>
        </select>
      </div>
      <div class="salutation">
        <select
          class="form-control"
          id="salutation"
          name="salutation"
          [(ngModel)]="salutation"
          [disabled]="isSending || isSended"
        >
          <option value="" disabled>Anrede</option>
          <option value="Frau">Frau</option>
          <option value="Herr">Herr</option>
        </select>
      </div>
      <div class="lastname">
        <input
          type="text"
          class="form-control"
          placeholder="Nachname *"
          id="lastname"
          name="lastname"
          [(ngModel)]="lastname"
          [disabled]="isSending || isSended"
          required
        />
      </div>
      <div class="firstname">
        <input
          type="text"
          class="form-control"
          placeholder="Vorname"
          id="firstname"
          name="firstname"
          [(ngModel)]="firstname"
          [disabled]="isSending || isSended"
        />
      </div>
      <div class="email">
        <input
          type="email"
          class="form-control"
          placeholder="E-Mail-Adresse *"
          id="email"
          name="email"
          [(ngModel)]="email"
          [disabled]="isSending || isSended"
          required
        />
      </div>
      <div class="phone">
        <input
          type="text"
          class="form-control"
          placeholder="Telefonnummer"
          id="phone"
          name="phone"
          [(ngModel)]="phone"
          [disabled]="isSending || isSended"
        />
      </div>
      <div class="company">
        <input
          type="text"
          class="form-control"
          placeholder="Firma *"
          id="company"
          name="company"
          [(ngModel)]="company"
          [disabled]="isSending || isSended"
          required
        />
      </div>
      <div class="devision">
        <input
          type="text"
          class="form-control"
          placeholder="Abteilung"
          id="devision"
          name="devision"
          [(ngModel)]="devision"
          [disabled]="isSending || isSended"
        />
      </div>
      <div class="function">
        <input
          type="text"
          class="form-control"
          placeholder="Funktion im Unternehmen"
          id="function"
          name="function"
          [(ngModel)]="function"
          [disabled]="isSending || isSended"
        />
      </div>
      <div class="privacy">
        <input
          type="checkbox"
          id="privacy"
          name="privacy"
          [(ngModel)]="privacy"
          [disabled]="isSending || isSended"
          required
        />
        <label for="privacy"
          >Ich erkenne die
          <a [routerLink]="['/privacy']">Datenschutzerklärung</a> an.</label
        >
      </div>
      <div class="send">
        <button
          class="send"
          (click)="send()"
          [disabled]="!webinarForm.form.valid || isSending || isSended"
        >
          Absenden
        </button>
      </div>
    </div>
    <div class="success" [hidden]="!isSended">
      <div class="picture">
        <img src="assets/v2m-logo.svg" />
      </div>
      <div class="text">
        <p>
          Vielen Dank für Ihre Anmeldung. Wir freuen uns auf das Webinar mit
          Ihnen.
        </p>
      </div>
    </div>
  </form>
</section>
